// extracted by css-extract-rspack-plugin
export default {"maxHeight":"TimeTrackingTabPanel_maxHeight__MOTFF"};